import { render } from "./IconChevronDownTiny.vue?vue&type=template&id=352a2a84"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronDownTiny.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "352a2a84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('352a2a84', __exports__)) {
    api.reload('352a2a84', __exports__)
  }
  
  module.hot.accept("./IconChevronDownTiny.vue?vue&type=template&id=352a2a84", () => {
    api.rerender('352a2a84', render)
  })

}


export default __exports__